import { all } from 'redux-saga/effects';
import { watchRestaurantSaga } from './restaurantSaga';
import { watchMenuItemsSaga } from './menuItemsSaga';
import { watchMenuItemDetailsSaga } from './menuItemDetailsSaga';
import { watchTpnConfigSaga } from './tpnConfigSaga';
import { watchImageUploadSaga } from './imageUploadSaga';
import { watchSiteContentSaga } from './siteContentSaga';
import { watchWidgetDataEnrichment } from './widgetDataEnrichmentSaga';
import { watchOrderSaga } from './orderSaga';
import { watchTimeSlotsSaga } from './timeSlotsSaga';
import { watchMakeReservationSaga } from './makeReservationSaga';
import { watchSubscriptionSaga } from './subscriptionSaga';
import { categoriesSaga } from './categoriesSaga';
import { modifiersSaga } from './modifiersSaga';

export default function* rootSaga() {
  yield all([
    watchRestaurantSaga(), 
    watchMenuItemsSaga(), // NEW API - Menu items list
    watchMenuItemDetailsSaga(), // NEW API - Menu item details
    watchTpnConfigSaga(), 
    watchImageUploadSaga(),
    watchSiteContentSaga(),
    watchSubscriptionSaga(), // Subscription check for commerce_ai addon
    watchWidgetDataEnrichment(), // Enriches widgets with menu data
    watchOrderSaga(),
    watchTimeSlotsSaga(),
    watchMakeReservationSaga(),
    categoriesSaga(),
    modifiersSaga(),
  ]);
}
